// extracted by mini-css-extract-plugin
export default {"form_container":"FormContainer_form_container__TnUFE"};